import type { Module } from '@vue-storefront/sdk';
import { connector } from './connector';
import type { ModuleOptions } from './types';

/**
 * @deprecated This type is deprecated and will be removed in the next major version.
 * It is no longer necessary to use this type. Please, check documentation of `magentoModule`.
 */
export interface EpicorModuleType extends Module {
  connector: ReturnType<typeof connector>;
}

/**
*
 * export const sdk = initSDK(sdkConfig);
 *
 * // Breaking changes:
 * // - Custom queries are now a second argument of the methods.
 *
 * const customQuery = {
 *   cart: 'entries-custom-query',
 *   metadata: {
 *     fields: 'id items { uid }'
 *   }
 * };
 * - const cart = await sdk.epicor.exampleMethod({ id: '123'}, { customQuery });
 *
 * ```
 *
 * @example
 * Initialization of the Magento module.
 *
 * ```js
 * import { initSDK, buildModule } from '@vue-storefront/sdk';
 * import { epicorModule, EpicorModuleType } from '@epicor/sdk';
 *
 * const sdkConfig = {
 *   statanuc:
 *     buildModule(
 *       epicorModule,
 *       {
 *         apiUrl: 'http://localhost:8181/epicor',
 *       }
 *     )
 * };
 *
 * export const sdk = initSDK<typeof sdkConfig>(sdkConfig);
 * ```
 */
export const epicorModule = (options: ModuleOptions) => {
  return {
    connector: connector(options),
  } satisfies Module;
};

export { client } from './client';
export type * from './methods';
